export default __webpack_public_path__ + "static/swash-e2844c7c27508e7600a5b7af6aa26004.svg";